import { render, staticRenderFns } from "./ViewNotifications.vue?vue&type=template&id=f39ff504&scoped=true"
import script from "./ViewNotifications.vue?vue&type=script&lang=js"
export * from "./ViewNotifications.vue?vue&type=script&lang=js"
import style0 from "./ViewNotifications.vue?vue&type=style&index=0&id=f39ff504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39ff504",
  null
  
)

export default component.exports